import { useEffect, useState } from 'react';
import { isStoreOpenAt } from './businessHours';

export function useStoreHours() {
  const [open, setOpen] = useState(() => isStoreOpenAt());
  useEffect(() => {
    let timer;
    const refresh = () => {
      clearTimeout(timer);
      setOpen(isStoreOpenAt());
      timer = setTimeout(refresh, 60000 - (Date.now() % 60000));
    };
    refresh();
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, []);
  return open;
}